import React from 'react'
import ExpenseDate from '../ExpenseData/ExpenseDate'
import Card from '../UI/Card'
import './ExpenseItem.css'

const ExpenseItem = (props) => {
  return (
    <ul className='expense-list'>
        
        <Card className='center'>
            <li>
                <div className="flex-start">
                    <div className="date">
                            <ExpenseDate date={props.date}/>
                        </div>
                        <div className="expense-name">{props.title}</div>
                    </div>
                <div className="price">{props.amount}</div>
            </li>
        </Card>
  </ul>
  )
}

export default ExpenseItem